import { render, staticRenderFns } from "./DialogCampaignCreate.vue?vue&type=template&id=0c19fa48&scoped=true"
import script from "./DialogCampaignCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogCampaignCreate.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DialogCampaignCreate.vue?vue&type=style&index=0&id=0c19fa48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c19fa48",
  null
  
)

export default component.exports